enum FundAccountType {
  ASK = 'ASK',
  IPS = 'IPS',
  GENERAL = 'GENERAL',
}
export default FundAccountType;
